import axios from 'axios'
import { MapperService, FeatureSwitchService } from '.'
import { FEATURES, URLS } from '../factories'
import { TRANSITION_STATE } from '../const'
import { ApplicationModule, AuthModule } from '../store'
import { SendFullAppResponse } from '../types/sendFullAppResponse'

export default {
  async sendFullApp (appInsights: any) {
    let token = AuthModule.token && AuthModule.token.authenticationToken ? AuthModule.token.authenticationToken : null
    if (token) {
      let tokenUpdateTime = AuthModule.token && AuthModule.token.tokenUpdateTime ? AuthModule.token.tokenUpdateTime : 0
      let authenticationTokenLifetime = AuthModule.token && AuthModule.token.authenticationTokenLifetime ? AuthModule.token.authenticationTokenLifetime  : 0
      if (tokenUpdateTime + authenticationTokenLifetime < Math.floor(Date.now() / 1000) ) {
        await AuthModule.updateAuthToken();
        token = AuthModule.token && AuthModule.token.authenticationToken !== null ? AuthModule.token.authenticationToken : null
      }

      const tokenString = 'Bearer ' + token
      const headersObj = { Authorization: tokenString }

      // Complete application
      if (ApplicationModule.fullAppSuccess === false) {
        const fullApps = JSON.parse(JSON.stringify(MapperService.map()))

        fullApps.agreedTermsAndConditions = true
        fullApps.isCompleted = true

        const delegateFn = () => {
          const applicationApiFullUrl = AuthModule.isProduction ? URLS.production.applicationApiFullUrl : URLS.replica.applicationApiFullUrl

          ApplicationModule.updateLockDown(true)

          if (ApplicationModule.GUID === '') {
            ApplicationModule.updateGUID()
          }

          axios({
            method: 'POST',
            url: applicationApiFullUrl + '/api/application/' + ApplicationModule.GUID,
            headers: headersObj,
            data: fullApps
          }).then(response => {
            const data = response.data as SendFullAppResponse

            const statusCode = data.accountCreationStatusCode

            if (statusCode === 1 || statusCode === 2) {
              ApplicationModule.updateMembersURL(data.membersUrl)

              ApplicationModule.updatFullAppSuccess(true)

              if (statusCode === 2) {
                ApplicationModule.updateIsDuplicateApp(true)
              }
            }

            window.sessionStorage.clear()

            let url = data.membersUrl

            if (url.includes('?')) {
              url = url + '&showMarketingPreferences=true'
            } else {
              url = url + '?showMarketingPreferences=true'
            }

            if (statusCode === 1) {
              appInsights.trackEvent({
                name: 'Application Form - Complete App',
                properties: {
                  event_category: 'Application Form',
                  event_action: 'Complete App',
                  event_label: ApplicationModule.GUID
                }
              })

              setTimeout(function () {
                window.location.replace(url)
              }, 3000)
            }

            if (statusCode === 2) {
              appInsights.trackEvent({
                name: 'Application Form - Complete App Duplicate',
                properties: {
                  event_category: 'Application Form',
                  event_action: 'Complete App Duplicate',
                  event_label: ApplicationModule.GUID
                }
              })

              setTimeout(function () {
                window.location.replace(url)
              }, 3000)
            }

            if (statusCode < 1 || statusCode > 2) {
              appInsights.trackEvent({
                name: 'Application Form - Complete App Status Code Error',
                properties: {
                  event_category: 'Application Form',
                  event_action: 'Complete App Status Code Error',
                  event_label: ApplicationModule.GUID,
                  status_code: statusCode
                }
              })
            }
          }).catch(() => {
            const requestData = fullApps

            appInsights.trackEvent({
              name: 'Application Form - Complete App Error',
              properties: {
                event_category: 'Application Form',
                event_action: 'Complete App Error',
                event_label: ApplicationModule.GUID,
                data: requestData
              }
            })

            window.sessionStorage.clear()
          })
        }

				delegateFn();
      }
    }
  }
}
